<script setup lang="ts">
import { useNuxtApp } from '@nuxt/bridge/dist/runtime'
const MyBalanceBox = () => import('@/components/molecules/MyBalanceBox.vue')

// Nuxt
const nuxtApp = useNuxtApp()
const { nuxt2Context }: any = nuxtApp
const { localePath } = nuxt2Context

</script>

<template>
	<div>
		<div class="tabs">
			<button @click="$router.push(localePath('market-index-shop-index-ppdshop-index-sale'))"
				:class="{ active: nuxtApp.$route.name.includes('sale') }">
				{{ $t("ppd.sale") }}
			</button>
			<button @click="$router.push(localePath('market-index-shop-index-ppdshop-index-purchaseppd'))"
				:class="{ active: nuxtApp.$route.name.includes('purchaseppd') }">
				{{ $t('ppd.purchasePpd') }}
			</button>
		</div>
		<MyBalanceBox class="mt-2 ml-auto" :mode="'ppd'" />
	</div>
</template>

<style lang="scss" scoped>
.tabs {
	button {
		@extend %tab--two;
	}
}
</style>
